export const DRIVER_PERSON_TYPES = Object.freeze({
  COORDINADOR: 'COORDINADOR',
  PUNTERO: 'PUNTERO',
  VOTANTE: 'VOTANTE',
  EXTERNO: 'EXTERNO',
});

export const DRIVER_PERSON_TYPE_LABELS = Object.freeze({
  [DRIVER_PERSON_TYPES.COORDINADOR]: 'Coordinador',
  [DRIVER_PERSON_TYPES.PUNTERO]: 'Puntero',
  [DRIVER_PERSON_TYPES.VOTANTE]: 'Votante',
  [DRIVER_PERSON_TYPES.EXTERNO]: 'Persona externa',
});

export const DRIVER_STATUSES = Object.freeze({
  AVAILABLE: 'AVAILABLE',
  ASSIGNED: 'ASSIGNED',
  INACTIVE: 'INACTIVE',
});

export const DRIVER_STATUS_META = Object.freeze({
  [DRIVER_STATUSES.AVAILABLE]: { label: 'Disponible', variant: 'success' },
  [DRIVER_STATUSES.ASSIGNED]: { label: 'Asignado', variant: 'info' },
  [DRIVER_STATUSES.INACTIVE]: { label: 'Inactivo', variant: 'neutral' },
});
